import data from "../../../../../src/Text/Text.docs.json";
import * as React from 'react';
export default {
  data,
  React
};